import { EMPTY_STATE_CHART_MIN, EMPTY_STATE_CHART_MAX } from '@shopify/polaris-viz-core';

function yAxisMinMax(series) {
  if (series.length === 0) {
    return {
      minY: EMPTY_STATE_CHART_MIN,
      maxY: EMPTY_STATE_CHART_MAX
    };
  }

  let minY = Infinity;
  let maxY = -Infinity;
  series.forEach(({
    data
  }) => {
    data.forEach(({
      value
    }) => {
      if (value == null) {
        return;
      }

      minY = Math.min(minY, value);
      maxY = Math.max(maxY, value);
    });
  });

  if (minY === Infinity || maxY === -Infinity) {
    return {
      minY: Math.min(minY, EMPTY_STATE_CHART_MIN),
      maxY: Math.max(maxY, EMPTY_STATE_CHART_MAX)
    };
  }

  return {
    minY,
    maxY
  };
}

export { yAxisMinMax };
